import { ParsedUrlQuery } from "querystring";

export default function getParam(
  { query }: { query: ParsedUrlQuery },
  paramName: string,
): string | null {
  const paramValue = query[paramName];
  if (!paramValue) {
    return null;
  }
  return (Array.isArray(paramValue) ? paramValue[0] : paramValue) ?? null;
}

export function getArrayParam({ query }: { query: ParsedUrlQuery }, paramName: string): string[] {
  const paramValue = query[paramName];
  if (!paramValue) {
    return [];
  }
  return Array.isArray(paramValue) ? paramValue : [paramValue];
}

export function getIndustrySlug(arg: { query: ParsedUrlQuery }) {
  return getParam(arg, "industry") ?? "all";
}

export function getTopicSlug(arg: { query: ParsedUrlQuery }) {
  return getParam(arg, "topic") ?? "all";
}

export function getSearchQuery(arg: { query: ParsedUrlQuery }) {
  return getParam(arg, "q") || undefined;
}
